import React from 'react';

interface TripTemplateImageSelectorProps {
  images: string[];
  selectedImage: string | null;
  onSelect: (image: string) => void;
}

export default function TripTemplateImageSelector({
  images,
  selectedImage,
  onSelect,
}: TripTemplateImageSelectorProps) {
  return (
    <div className="mt-2 overflow-x-auto grid grid-flow-col auto-cols-max gap-3 h-full">
      {images.map((image) => (
        <div
          key={image}
          className={[
            'h-32 w-32 rounded-md overflow-hidden ring-4 my-1.5 mx-1',
            selectedImage === image ? 'ring-orange-500' : 'ring-gray-300',
          ].join(' ')}
          onClick={() => onSelect(image)}
        >
          <img
            className="h-full w-full object-cover"
            src={image}
            alt="suggested"
          />
        </div>
      ))}
    </div>
  );
}
